import reducer from './reducers';

export { default as bookSelectors } from './selectors';
export { default as bookOperations } from './operations';
export { default as bookTypes } from './types';

export default reducer;
